<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('proveedores.proveedores')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <!-- rList Table CARD-->
      <r-list
        ref="rlist"
        slot="default"
        :dbAdapter="Proveedor"
        sort="creationDate"
        sortDir="DESC"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        filtersName="proveedores"
      >
        <template v-slot:before="{rlist}">
          <f7-card-header>
            <div class="data-table-header" v-if="Object.keys(rlist.selected).length==0">
              <div class="data-table-links">
                <a class="link" href="/proveedores/new/">Nuevo</a>
              </div>
              <div class="data-table-actions">
                <f7-link small @click="rlist.reload()" icon-f7="arrow_counterclockwise"></f7-link>
                <f7-link small @click="rlist.exportExcel('Proveedores.xlsx')" icon-f7="doc_text_fill"  v-tooltip="'Exportar a Excel'"></f7-link>
                <f7-link
                  small
                  @click="$refs.rpanel.toggle()"
                  icon-f7="line_horizontal_3_decrease"
                  v-show="!rPanelOpenedByBreakpoint"
                ></f7-link>
              </div>
            </div>
            <div class="data-table-header-selected display-flex" v-else>
              <!-- Selected table title -->
              <div class="data-table-title-selected">
                <span
                  class="data-table-selected-count"
                >{{$tc('rlist.n_registros_seleccionados', Object.keys(rlist.selected).length, {count:Object.keys(rlist.selected).length}) }}</span>
              </div>
              <!-- Selected table actions -->
              <div class="data-table-actions">
                <f7-link icon-f7="trash"></f7-link>
              </div>
            </div>
          </f7-card-header>
        </template>

        <template v-slot:header="{rlist}">
          <thead class="thead-sticky">
            <tr>
              <th class="checkbox-cell" style="width: 2rem;">
                <label class="checkbox">
                  <input type="checkbox" @change="rlist.toggleSelectAll($event.target.checked)" />
                  <i class="icon-checkbox"></i>
                </label>
              </th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('codigo')"
                :class="rlist.sortableClasses('codigo')"
              >{{$t('proveedores.codigo')}}</th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('nombre')"
                :class="rlist.sortableClasses('nombre')"
              >{{$t('proveedores.nombre')}}</th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('razonSocial')"
                :class="rlist.sortableClasses('razonSocial')"
              >{{$t('proveedores.razonSocial')}}</th>
              <th
                style="min-width:1em;"
              >{{$t('proveedores.nif')}}</th>
              <th
                style="min-width:1em;"
              >{{$t('proveedores.telefono')}}</th>
              <th
                style="min-width:1em;"
              >{{$t('proveedores.email')}}</th>
              <th style="width:7em;" class="label-cell text-align-center right-column-sticky">
                <f7-icon f7="gear_alt_fill"></f7-icon>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:default="{vlData,rlist}">
          <tr v-for="(item) in vlData.items" :key="'proveedor-'+item.id">
            <th class="checkbox-cell">
              <label class="checkbox">
                <input
                  type="checkbox"
                  :checked="item.id in rlist.selected"
                  @change="rlist.toggleSelect(item, $event.target.checked)"
                />
                <i class="icon-checkbox"></i>
              </label>
            </th>
            <td>{{item.codigo}}</td>
            <td>{{item.nombre}}</td>
            <td>{{item.razonSocial}}</td>
            <td>{{item.nif}}</td>
            <td>{{item.telefono}}</td>
            <td>{{item.email}}</td>
            <td class="text-align-right right-column-sticky">
              <f7-link icon-f7="eye" color="green" :href="`/proveedores/view/${item.id}/`"></f7-link>
              <f7-link icon-f7="square_pencil" color="blue" :href="`/proveedores/edit/${item.id}/`"></f7-link>
              <!-- <f7-link icon-f7="trash" color="red" @click="rlist.removeItem(item.id)"></f7-link> -->
            </td>
          </tr>
        </template>
        <template v-slot:afterInner="{rlist}">
          <rPanel
            ref="rpanel"
            side="right"
            @openedByBreakpoint="rPanelOpenedByBreakpoint=true"
            @closedByBreakpoint="rPanelOpenedByBreakpoint=false"
            v-slot="{rpanel}"
          >
            <r-form 
              @submit="rlist.setFilter($event); rpanel.close();"
              filtersName="proveedores"  
            >
              <template v-slot:before="{rform}">
                <f7-toolbar>
                  <div>Filtro</div>
                  <f7-link icon-f7="bin_xmark" @click="rform.clear();"></f7-link>
                </f7-toolbar>
              </template>
              <template v-slot="{rform}">
                <f7-list no-hairlines-md>
                  <template v-slot:list>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('proveedores.codigo')"
                      :form="rform"
                      type="text"
                      name="codigo"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('proveedores.nombre')"
                      :form="rform"
                      type="text"
                      name="nombre"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('proveedores.razonSocial')"
                      :form="rform"
                      type="text"
                      name="razonSocial"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('proveedores.nif')"
                      :form="rform"
                      type="text"
                      name="nif"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('proveedores.telefono')"
                      :form="rform"
                      type="text"
                      name="telefono"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('proveedores.email')"
                      :form="rform"
                      type="text"
                      name="email"
                    ></r-input>
                    <f7-button type="submit" class="margin-vertical" icon-f7="search">Buscar</f7-button>
                  </template>
                </f7-list>
              </template>
            </r-form>
          </rPanel>
        </template>
        <template v-slot:after="{rlist}">
          <f7-card-footer>
            <span>
              <b>{{$tc('rlist.n_registros', rlist.count, {count:rlist.count})}}</b>
            </span>
          </f7-card-footer>
        </template>
      </r-list>
    </f7-page-content>
  </f7-page>
</template>
<script>
import rList from "./../../components/rList.vue";
import rPanel from "./../../components/rPanel.vue";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import Proveedor from "./../../js/db/Proveedor.js";
export default {
  components: {
    rList,
    rPanel,
    rForm,
    rInput,
    rAutocomplete
  },
  data() {
    return {
      Proveedor,
      rPanelOpenedByBreakpoint: false
    };
  },
  computed: {},
  methods: {
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    /*app.dataTable.create({
      el: self.$refs.datatable
    });*/
  }
};
</script>